import React from 'react';
import Marquee from 'react-fast-marquee';
import { PARTNER_LOGOS } from '../../data/siteData';

export const TrustedBy = () => (
  <section data-testid="trusted-by-section" className="py-12 bg-white border-y border-slate-200">
    <div className="max-w-7xl mx-auto px-6 md:px-12 mb-8">
      <p className="text-center text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
        Trusted by growing businesses &amp; enterprise teams across India
      </p>
    </div>
    <Marquee speed={32} gradient gradientColor="#ffffff" gradientWidth={100}>
      {PARTNER_LOGOS.map((name) => (
        <div key={name} className="mx-10 flex items-center gap-2 select-none opacity-50 hover:opacity-90 transition-opacity">
          <span className="w-2 h-2 rounded-sm bg-[#0A192F]" />
          <span className="text-lg font-bold text-[#0A192F] font-heading tracking-tight">{name}</span>
        </div>
      ))}
    </Marquee>
  </section>
);
